var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid grey lighten-5 pt-4"},[_c('h2',{staticClass:"h2"},[_vm._v("Archivo de precios")]),_c('br'),_c('card',[_c('iframe',{staticClass:"iframe-list-price",attrs:{"src":"https://www.iusa.com.mx/listas_de_precios"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }